import { useNewHotelSearch } from './ChatTripPlannerPage/contexts/NewHotelSearchContext'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import LineBugIcon from 'LuxKit/Icons/line/LineBugIcon'
import Switch from 'LuxKit/Switch/Switch'
import Group from 'components/utils/Group'

const STAFF_TOOL_ICON = <LineBugIcon />

interface Props {
  isDevMode: boolean
  isRewindMode: boolean
  onDevModeToggle: () => void
  onRewindModeToggle: () => void
}

function TripPlannerStaffTools({
  isDevMode,
  isRewindMode,
  onDevModeToggle,
  onRewindModeToggle,
}: Props) {
  const { canUseNewHotelSearch, useNewHotelSearch: newHotelSearchEnabled, toggleNewHotelSearch } = useNewHotelSearch()
  const intl = useIntl()
  const newHotelSearchLabel = intl.formatMessage({
    id: 'k0VvzZ-L-MFLRrYZpRKn',
    defaultMessage: 'New hotel search',
    description: 'Temporary staff-only toggle for the new hotel search implementation in Trip Chat',
  })
  const devModeLabel = intl.formatMessage({
    id: '5qA-UbYrn6NV99xwjE8i',
    defaultMessage: 'Dev mode',
    description: 'Toggle label for enabling developer mode in the TripPlanner side nav and menu drawer',
  })
  const rewindModeLabel = intl.formatMessage({
    id: '7_8iRKL2s3hpHNYSet-C',
    defaultMessage: 'Rewind mode',
    description: 'Toggle label for enabling staff rewind features in the TripPlanner side nav and menu drawer',
  })

  return (
    <Group direction="vertical" gap={12}>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: '7VHq3D8gYsa0RI2PGsfi',
          defaultMessage: 'Staff tools',
          description: 'Label for the staff-only tools section in the TripPlanner side nav and menu drawer',
        })}
      </BodyText>
      {canUseNewHotelSearch && (
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
          <BodyText variant="medium">{newHotelSearchLabel}</BodyText>
          <Switch checked={newHotelSearchEnabled} onChange={toggleNewHotelSearch} aria-label={newHotelSearchLabel} />
        </Group>
      )}
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
        <Group direction="horizontal" gap={8} verticalAlign="center">
          {STAFF_TOOL_ICON}
          <BodyText variant="medium">{devModeLabel}</BodyText>
        </Group>
        <Switch checked={isDevMode} onChange={onDevModeToggle} aria-label={devModeLabel} />
      </Group>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
        <Group direction="horizontal" gap={8} verticalAlign="center">
          {STAFF_TOOL_ICON}
          <BodyText variant="medium">{rewindModeLabel}</BodyText>
        </Group>
        <Switch checked={isRewindMode} onChange={onRewindModeToggle} aria-label={rewindModeLabel} />
      </Group>
    </Group>
  )
}

export default TripPlannerStaffTools
